module.exports = __webpack_public_path__ + "img/whiterightarrow.cb3fad9a.svg";